import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {NgClassType} from "../../model/common.model";
import {JsonPipe, NgClass, NgIf} from "@angular/common";
import {ReflectedType, ReflectorService} from "../../services/reflector.service";

@Component({
  selector: 'error-panel',
  templateUrl: './error-panel.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    JsonPipe
  ]
})
export class ErrorPanelComponent implements OnInit, OnChanges {

  @Input() ngClass: NgClassType
  @Input() errorHeading?: string = 'An error has occurred'
  @Input() error: any

  errorType: ReflectedType = 'null'
  expandedStackTrace = false
  expandedUserInfo = false

  get httpError(): HttpErrorResponse | undefined {
    if (this.error instanceof HttpErrorResponse) {
      return this.error
    }
    return undefined
  }

  get hasStackTrace(): boolean {
    return this.error && 'error' in this.error && 'stackTrace' in this.error['error']
  }

  get hasUserInfo(): boolean {
    console.warn(this.error != null, 'error' in this.error && 'userInfo' in this.error['error'])
    return this.error
      && 'error' in this.error
      && 'userInfo' in this.error['error']
      && this.error['error']['userInfo'] != null
  }

  get userInfo() {
    return this.error['error']['userInfo']
  }

  constructor(
    readonly reflector: ReflectorService
  ) {
  }

  ngOnChanges(_: SimpleChanges): void {
    this.errorType = this.reflector.getReflectedType(this.error)
  }

  ngOnInit(): void {
  }

}
